import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useBellNotification(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getData() {
    return privateFetch.get(`/v1/admin/action-centre`, configs).then((res) => res.data);
  }

  return useQuery(['user-action-centre'], getData, {
    enabled,
  });
}

export default useBellNotification;
